import * as React from 'react';
const SvgArrowRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M17.95 11.685c-.07-.23-4.18-4.332-4.18-4.332-.2-.2-.3-.3-.41-.33a.55.55 0 0 0-.31 0c-.11.04-.21.14-.41.33l-.28.28-.19.19c-.08.08-.12.15-.14.22-.03.1-.03.21 0 .31.04.11.14.21.33.41l2.23 2.232H6.5c-.28 0-.5.22-.5.5v1c0 .28.22.5.5.5h8.09l-2.23 2.232c-.2.2-.3.3-.33.41-.03.1-.03.21 0 .31.04.11.14.21.33.41l.28.28c.13.13.22.22.3.28a.3.3 0 0 0 .11.06c.1.03.21.03.31 0 .11-.04.21-.14.41-.33 0 0 4.11-4.102 4.18-4.332a1 1 0 0 0 0-.62z"
    />
  </svg>
);
export default SvgArrowRight;
